import { useMutation } from '@tanstack/react-query';

import { updateFeedbacks } from '../api/feedback.api';
import { UpdateFeedback } from '../feedback.types';

interface UpdateFeedbacksParams {
    id: number;
    body: UpdateFeedback;
}

export const useUpdateFeedbacks = () => {
    return useMutation({
        mutationFn: ({ id, body }: UpdateFeedbacksParams) =>
            updateFeedbacks(id, body),
    });
};
